import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
export function AccordionHeader(props) {
    const { title, endElement } = props;
    return (<Box alignItems="center" justifyContent="space-between" px="md">
      <Typography $appearance="300" $fontSize="small" $fontWeight="medium">
        {title}
      </Typography>
      {endElement}
    </Box>);
}
